// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customFilter {
  padding: 0.75rem;
}

.customSelect {
  position: relative;
}

.customSelect select {
  appearance: none;
  width: 220px;
  height: 36px;
  padding: 0rem 0.5rem;
  background-color: #ffffff;
  outline: none;
  border-radius: 0.25rem;
  color: #353535;
  cursor: pointer;
}

.inputsDiv {
  margin: 0.5rem 0rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.inputsDiv input {
  width: 220px;
  padding: 0rem 0.25rem;
  background-color: #ffffff;
  outline: none;
  border-radius: 0.25rem;
  border: 1px solid rgba(0, 0, 0, 0.3);
  color: #353535;
  cursor: pointer;
}

.customSelect::after {
  --size: 0.35rem;
  content: "";
  position: absolute;
  right: 0.6rem;
  pointer-events: none;
}

.customSelect::after {
  border-left: var(--size) solid transparent;
  border-right: var(--size) solid transparent;
  border-top: var(--size) solid black;
  top: 45%;
}

/* src/FilterComponent.css */
.filter-container {
  width: 300px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.filter-search-input {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.filter-checkbox-group {
  margin-bottom: 10px;
}

.filter-button {
  background-color: #034EA2;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 10px;
}

.filter-button:hover {
  background-color: #0056b3;
}

.filter-checkbox-group {
  margin-bottom: 10px;
  /* Use flex or block to stack labels vertically */
  display: flex;
  flex-direction: column;
}

.filter-checkbox-label {
  margin-bottom: 8px;
  /* Optional: Add spacing between labels */
  display: block;
  /* Ensures each label takes a new line */
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/customFilter.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,mCAAmC;EACnC,QAAQ;AACV;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;EACd,wCAAwC;AAC1C","sourcesContent":[".customFilter {\n  padding: 0.75rem;\n}\n\n.customSelect {\n  position: relative;\n}\n\n.customSelect select {\n  appearance: none;\n  width: 220px;\n  height: 36px;\n  padding: 0rem 0.5rem;\n  background-color: #ffffff;\n  outline: none;\n  border-radius: 0.25rem;\n  color: #353535;\n  cursor: pointer;\n}\n\n.inputsDiv {\n  margin: 0.5rem 0rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.inputsDiv input {\n  width: 220px;\n  padding: 0rem 0.25rem;\n  background-color: #ffffff;\n  outline: none;\n  border-radius: 0.25rem;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  color: #353535;\n  cursor: pointer;\n}\n\n.customSelect::after {\n  --size: 0.35rem;\n  content: \"\";\n  position: absolute;\n  right: 0.6rem;\n  pointer-events: none;\n}\n\n.customSelect::after {\n  border-left: var(--size) solid transparent;\n  border-right: var(--size) solid transparent;\n  border-top: var(--size) solid black;\n  top: 45%;\n}\n\n/* src/FilterComponent.css */\n.filter-container {\n  width: 300px;\n  background-color: #f5f5f5;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 15px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.filter-search-input {\n  width: 100%;\n  padding: 8px;\n  margin-bottom: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.filter-checkbox-group {\n  margin-bottom: 10px;\n}\n\n.filter-button {\n  background-color: #034EA2;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-right: 10px;\n}\n\n.filter-button:hover {\n  background-color: #0056b3;\n}\n\n.filter-checkbox-group {\n  margin-bottom: 10px;\n  /* Use flex or block to stack labels vertically */\n  display: flex;\n  flex-direction: column;\n}\n\n.filter-checkbox-label {\n  margin-bottom: 8px;\n  /* Optional: Add spacing between labels */\n  display: block;\n  /* Ensures each label takes a new line */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
